import { Component, OnInit, ViewChild, AfterViewInit, TemplateRef  } from '@angular/core'
import { locale as en } from '../i18n/en'
import { locale as fr } from '../i18n/fr'
import { locale as de } from '../i18n/de'
import { locale as pt } from '../i18n/pt'
import { CoreTranslationService } from '@core/services/translation.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CoreConfigService } from '@core/services/config.service';
import { ColumnMode, DatatableComponent, id } from '@swimlane/ngx-datatable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { ApiService } from 'app/main/services/Api/api.service'
import { HttpErrorResponse } from '@angular/common/http'
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms'
import { ToastService } from 'app/main/services/Toast/toast.service'
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { ExcelService } from 'app/services/Excel/excel.service'

@Component({
  selector: 'app-organizer-report',
  templateUrl: './organizer-report.component.html',
  styleUrls: ['./organizer-report.component.scss']
})
export class OrganizerReportComponent implements OnInit {

  public contentHeader: object
  organizers: any
  showTable: boolean = false
  searchForm: FormGroup
  organizerReport: any[] = []
  organizerReportLength: number = 0

  constructor(private _coreTranslationService: CoreTranslationService,
    private modalService: NgbModal,private api: ApiService,private formBuilder: FormBuilder,
    public toastService: ToastService,private excelService: ExcelService) {
    this._coreTranslationService.translate(en, fr, de, pt)

    const today = new Date();
    const startOfYear = new Date(today.getFullYear(), 0, 1);
    const endOfYear = new Date(today.getFullYear(), 11, 31);

    this.searchForm = this.formBuilder.group({
      OrganizerId: ['', [Validators.required]],
      DateFrom: [this.getFormattedDate(startOfYear), [Validators.required]],
      DateTo: [this.getFormattedDate(endOfYear), [Validators.required]],
    }, { validator: this.dateRangeValidator });
  }

  getFormattedDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  ngOnInit(): void {
    this.showOrganizers()
  }

  showOrganizers(){
    this.api.showAllOrganizers(1,100).subscribe({
      next: (response) => {
        console.log(response.data)
        this.organizers = response.data.map( (item,index)=>({
          id: item.id,
          organizer: item.nameAr || item.nameEn,
        }))
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })
  }

  search(){
    this.showTable = false
    this.searchForm.markAllAsTouched();
    if(this.searchForm.valid){
      console.log(this.searchForm.value)
      this.api.organizerReport(this.searchForm.value.OrganizerId,
        this.searchForm.value.DateFrom,
        this.searchForm.value.DateTo).subscribe({
          next: (response) => {
            console.log(response.data)
            this.organizerReport = response.data.map( (item,index)=>({
              '#': index + 1,
              'organizer': item.organizer?.nameAr || item.organizer?.nameEn || '',
              'email': item.organizer?.email || '',
              'phoneNumber': '',
              'event': item.event?.nameAr || item.event?.nameEn || '',
              'startDate': item.event?.startTime || '',
              'endDate': '',
            }))
            this.organizerReportLength = this.organizerReport.length
            this.showTable = true
          }, error: (error: HttpErrorResponse) => {
            console.log(error)
            // this.alert
          }
        })
    }
  }

  dateRangeValidator(form: FormGroup): ValidationErrors | null {
    const dateFrom = form.get('DateFrom')?.value;
    const dateTo = form.get('DateTo')?.value;

    if (dateFrom && dateTo && new Date(dateTo) < new Date(dateFrom)) {
      return { dateRangeInvalid: true };
    }
    return null;
  }

  // exportExcel(){
  //   console.log(this.searchForm.value)
  // }

  excel_data :any= []
  exportExcel() {
    // Prepare data with clean Arabic headers
    console.log(this.organizerReport)
    const cleanData = this.organizerReport.map((item,index) => ({
      '#': index + 1,
      'المشرف': item.organizer,
      'البريد الالكتروني': item.email,
      'رقم الهاتف': item.phoneNumber,
      'اسم المناسبة': item.event,
      'تاريخ البدء': item.startDate ? item.startDate.split('T')[0] : '',
      'تاريخ الانتهاء': item.endDate ? item.endDate.split('T')[0] : ''
      // 'تاريخ الانتهاء': item.endDate,
    }));
  
    // Create worksheet
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(cleanData);
    
    // Define styles
    const headerStyle = {
      font: { bold: true, sz: 14, color: { rgb: 'FFFFFF' } },
      fill: { fgColor: { rgb: '4F81BD' } },
      alignment: { horizontal: 'center', vertical: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } }
      }
    };
  
    const titleStyle = {
      font: { bold: true, sz: 12, color: { rgb: '000000' } },
      fill: { fgColor: { rgb: 'FFFF00' } },
      alignment: { horizontal: 'center', vertical: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } }
      }
    };
  
    const dataStyleOdd = {
      fill: { fgColor: { rgb: 'D3D3D3' } },
      alignment: { horizontal: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } }
      }
    };
  
    const dataStyleEven = {
      fill: { fgColor: { rgb: 'FFFFFF' } },
      alignment: { horizontal: 'center' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        left: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } }
      }
    };
  
    // Apply header style (row 1)
    const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:Z1');
    for(let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ c: C, r: range.s.r });
      if(!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = headerStyle;
    }
  
    // Apply alternating row styles to data
    const dataRange = XLSX.utils.decode_range(worksheet['!ref'] || 'A1:Z100');
    for(let R = dataRange.s.r + 1; R <= dataRange.e.r; ++R) {
      for(let C = dataRange.s.c; C <= dataRange.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ c: C, r: R });
        if(!worksheet[cellAddress]) continue;
        
        // Apply odd/even row styling
        worksheet[cellAddress].s = R % 2 === 0 ? dataStyleEven : dataStyleOdd;
      }
    }
  
    // Set right-to-left direction for the sheet
    worksheet['!views'] = [{ rightToLeft: true }];
  
    // Create workbook
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };
    
    // Generate and save Excel file
    const excelBuffer: any = XLSX.write(workbook, { 
      bookType: 'xlsx', 
      type: 'array' 
    });
    
    const now = new Date();
    const current = now.getFullYear() + '-' + 
      (now.getMonth() + 1).toString().padStart(2, '0') + '-' + 
      now.getDate().toString().padStart(2, '0');
    const file_name = 'تقرير المشرفين ' + '-' + current;
    
    this.saveAsExcelFile(excelBuffer, file_name);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}.xlsx`);
  }

  export(){
    const headers = {
      organizer: 'المشرف',
      email: 'البريد الالكتروني',
      phoneNumber: 'رقم الهاتف',
      event: 'اسم المناسبة',
      startDate: 'تاريخ البدء',
      endDate: 'تاريخ الانتهاء'
    };
    this.excelService.exportExcel('تقرير المشرفين',this.organizerReport,headers)
  }

}
